import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

export default function BudgetDeleteModal({ show, onHide, onDelete }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center p-4">
        <div className="mb-3 text-danger fs-1">
          <FiTrash2 />
        </div>

        <h5>Confirm Delete</h5>
        <p>You want to delete selected items. This cannot be undone.</p>

        <div className="d-flex justify-content-center gap-2">
          <Button variant="light" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onDelete}>
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}